<template>
    <li class="faq-item" :class="{'faq-item--collapsed': collapsed}">
        <div class="faq-item__title" @click="collapseUncollapse">
            <slot name="title"  />
        </div>
        <div class="faq-item__content" @click="collapseUncollapse">
            <slot name="content" />
        </div>
        <a @click.prevent="collapseUncollapse" class="faq-item__collapse-button" />
    </li>
</template>
<script>
    export default {
        name: 'FaqItem',
        data () {
            return {
                collapsed: true
            }
        },
        methods: {
          collapseUncollapse () {
            this.collapsed = !this.collapsed;
          }
        }
    }
</script>
